import { Box, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import Translate from "../components/Translate";

export default function UnauthorizedPage() {
  const theme = useTheme();

  return (
    <Box
      sx={{ background: theme.palette.background.paper }}
      className="w-full h-screen flex flex-col justify-center items-center"
    >
      <img
        className="md:text-left text-center mb-12"
        src="/assets/bizpik-logo.svg"
        alt="bizpik-logo"
      />

      <Typography
        variant="h4"
        sx={{ fontSize: 24, fontWeight: 600, color: theme.palette.secondary.main }}
      >
        <Translate src="validation:page_unauthorized" />
      </Typography>

      <Typography
        component="p"
        sx={{ display: "block", fontWeight: 400, fontSize: 18, mt: 1.5 }}
      >
        <Translate
          src="validation:user_lost"
          components={{
            "1": (
              <Link
                style={{ color: theme.palette.primary.main }}
                className="underline underline-offset-4"
                to={process.env.REACT_APP_BIZPIK_FRONT_URL as string}
              />
            )
          }}
        />
      </Typography>
    </Box>
  );
}
